import { render, staticRenderFns } from "./badgeDetail.vue?vue&type=template&id=726f50a1&scoped=true&"
import script from "./badgeDetail.vue?vue&type=script&lang=js&"
export * from "./badgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./badgeDetail.vue?vue&type=style&index=0&id=726f50a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f50a1",
  null
  
)

export default component.exports